<div class="d-flex h-100 gap-2 period-selector-wrapper">
  <div #firstDateSelector>
    <ex-date-selector
      #firstDateSelectorComponent
      data-cy="search-period-from"
      tip="from"
      class="d-flex pdl-4px"
      [ngClass]="{ 'hidden-date-selector': !dbPeriod?.from && !dbPeriod?.to }"
      (dateSelect)="onDateSelection($event, 'from')"
      [inputPeriod]="dbPeriod"
      [inputDate]="dbPeriod?.from ?? undefined"
      [allowedDateRange]="allowedDateRange"
      [periodNotValid]="getDateNotValid('from')"
      (keydown.tab)="onTabKeyFirstSelector($event)"
      [explanations]="'filter.date-selector.' + periodField | translate"
      [allowEmptyDate]="allowEmptyPeriod"
    />
  </div>
  @if (dbPeriod?.from || dbPeriod?.to) {
    <div class="separator">
      <div class="separator-dot"></div>
    </div>
  }
  <div #secondDateSelector>
    <ex-date-selector
      #secondDateSelectorComponent
      data-cy="search-period-to"
      tip="to"
      class="d-flex"
      [ngClass]="{ 'hidden-date-selector': !dbPeriod?.to && !dbPeriod?.from }"
      (dateSelect)="onDateSelection($event, 'to')"
      [inputPeriod]="dbPeriod"
      [inputDate]="dbPeriod?.to ?? undefined"
      [allowedDateRange]="allowedDateRange"
      [periodNotValid]="getDateNotValid('to')"
      (keydown.tab)="onTabKeySecondSelector($event)"
      [explanations]="'filter.date-selector.' + periodField | translate"
      [allowEmptyDate]="allowEmptyPeriod"
    />
  </div>
  @if (!dbPeriod?.from && !dbPeriod?.to) {
    <div class="date-placeholder">
      <span class="placeholder-text" (click)="openDateSelector('from')">{{ 'filter.begin' | translate }}</span>
      <div class="separator-dot"></div>
      <span class="placeholder-text" (click)="openDateSelector('to')">{{ 'filter.end' | translate }}</span>
    </div>
  }
</div>
